import { render, staticRenderFns } from "./aboutUsBlock.vue?vue&type=template&id=60a214b4&scoped=true&"
import script from "./aboutUsBlock.vue?vue&type=script&lang=js&"
export * from "./aboutUsBlock.vue?vue&type=script&lang=js&"
import style0 from "./aboutUsBlock.vue?vue&type=style&index=0&id=60a214b4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a214b4",
  null
  
)

export default component.exports